// src/utils/botDetect.js
//
// Browser-side crawler check. Keeps obvious bots out of live presence and the
// visit log. The server (functions/analytics/botDetect.js) also checks IPs,
// which catches crawlers that use a normal-looking browser.

const BOT_UA_RE =
  /bot\b|bot\/|crawl|spider|slurp|facebookexternalhit|meta-external|facebookcatalog|headless|lighthouse|pagespeed|gtmetrix|pingdom|phantomjs|selenium|puppeteer|playwright/i;

export function isLikelyBot() {
  try {
    if (typeof navigator === "undefined") return true;
    return navigator.webdriver === true || BOT_UA_RE.test(navigator.userAgent || "");
  } catch {
    return false;
  }
}

export function isBotUserAgent(ua) {
  return BOT_UA_RE.test(String(ua || ""));
}
